import { render, staticRenderFns } from "./VersionEdit.vue?vue&type=template&id=4473fff3&"
import script from "./VersionEdit.vue?vue&type=script&lang=js&"
export * from "./VersionEdit.vue?vue&type=script&lang=js&"
import style0 from "./VersionEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports